import type { EntityEvent } from '@racemap/sdk/schema/entityEvents';
import { getLatLng } from '@racemap/utilities/functions/geo';
import { isPointWithinGeofence } from '@racemap/utilities/functions/geofence';
import { isPoint } from '@racemap/utilities/functions/validation';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import type { RacemapGeoObject } from '@racemap/utilities/types/geos';

export const filterAlertsAroundProtectedZones = ({
  event,
  features,
  alerts,
}: {
  event: RacemapEvent;
  features: Array<RacemapGeoObject>;
  alerts: Array<EntityEvent>;
}): Array<EntityEvent> => {
  const protectedZones = features
    .filter(isPoint)
    .filter((feature) => feature.properties?.disabledEntityEvents?.length > 0);
  const range = event?.modules.dataFeed.geofenceRange;
  if (protectedZones.length === 0 || range == null) return alerts;

  return alerts.filter((alert) => {
    const { lat, lng } = alert.location || {};
    if (lat == null || lng == null) return true;

    return !protectedZones.some(
      (zone) =>
        zone.properties.disabledEntityEvents.includes(alert.eventType) &&
        isPointWithinGeofence(getLatLng(zone.geometry), { lat, lng }, range / 2),
    );
  });
};
